import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-warn',
  templateUrl: './mobile-warn.component.html',
  styleUrls: ['./mobile-warn.component.scss']
})
export class MobileWarnComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
